import React from 'react'
import clsx from 'clsx'
import styles from './Skeleton.module.scss';

function Skeleton(props: any) {
  return (
    <div {...props} className={clsx(styles.skeleton, props?.className)} />
  )
}

export default Skeleton
